<template>
  <div class="news-container" ref="newsContainer">
    <div class="blank"></div>
    <div class="video-list">
      <div 
        class="video-item" 
        v-for="(video, index) in videos" 
        :key="index"
        :class="{ 'active': currentIndex === index }"
      >
        <div class = "date">
          <div class="timeline-date">{{ video.date }}</div>
        </div>
        
        <div class="timeline">
          <div class="timeline-container">
            <div class="timeline-line"></div>
            <div class="timeline-dot"></div>
          </div>
        </div>
          
        <div class="video-content">
          <div class="video-info">
            <h3 class="video-title">{{ video.title }}</h3>
          </div>
          <video 
            class="video-player"
            :src="video.url" 
            controls
            playsinline
            webkit-playsinline
            x5-playsinline
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            preload="auto"
            @play="handleVideoPlay(index)"
            @pause="handleVideoPause(index)"
          ></video>
          <div class="video-info">
            <p class="video-desc">{{ video.description }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="ending"></div>
    <div class="scroll-indicator" v-if="showScrollIndicator">
      <span>slide to view more</span>
      <i class="arrow-down"></i>
    </div>
    
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      currentIndex: 0,
      showScrollIndicator: true,
      videos: [],
      touchStartY: 0,
      isScrolling: false
    };
  },
  mounted() {
    this.fetchVideos();
    this.initTouchEvents();
    this.hideScrollIndicatorAfterDelay();
  },
  methods: {
    async fetchVideos() {
      try {
        // 优先从阿里云OSS获取视频数据
        const response = await fetch('https://le-times-website.oss-cn-beijing.aliyuncs.com/videos.json');
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.status}`);
        }
        const data = await response.json();
        console.log('Fetched videos from OSS:', data);
        this.videos = data;
      } catch (error) {
        console.error('There was a problem fetching the videos from OSS:', error);
        // 如果OSS获取失败，尝试从本地文件获取
        try {
          const localResponse = await fetch('/videos.json');
          if (localResponse.ok) {
            const localData = await localResponse.json();
            console.log('Fetched videos from local:', localData);
            this.videos = localData;
          } else {
            throw new Error('Local file also failed');
          }
        } catch (localError) {
          console.error('Both OSS and local fetch failed:', localError);
          // 如果都失败了，使用默认数据
          this.videos = [
            {
              title: "World Adventures",
              description: "Le-Times Entertainment was presented an international carnival 'World Adventures' featured with dynamic live entertainment and an international market that was bringing the whole globe to Beijing. Over 45 international-themed stalls, faces from over 20 countries gathered together there with nonstop immersive performances at Funworld Central Plaza, amazing!",
              date: "04.2025",
              url: "https://le-times-website.oss-cn-beijing.aliyuncs.com/FunWorld.m4v"
            },
            {
              title: "World Fashion Goddess Award 2025",
              description: "Le-Times collaborated with Sheguang Hu Studio team successfully hosted the \"World Fashion Goddess Award 2025\" at the Regent Hotel Beijing. Le-Times provided T-stage design, stage construction, AV systems, as well as live entertainment performances featuring international bands and professional DJs.  ",
              date: "03.2025",
              url: "https://le-times-website.oss-cn-beijing.aliyuncs.com/Sheguang_HU.m4v"
            },
            {
              title: "Wanderlust Bazaar",
              description: "From 29 Jan. 2025 to 5 Feb. 2025, during the Chinese Spring Festival, Le-Times successfully organized & executed the \"Wanderlust Bazaar\"at Parkview Green Shopping Mall. During this event, Le-Times collabrated with over 35 international vendors from over 18 countries participated this event which made a great influence and achievements. ",
              date: "01.2025",
              url: "https://le-times-website.oss-cn-beijing.aliyuncs.com/Fangcaodi.m4v"
            },
            {
              title: "International Art Fair Market",
              description: "From 1st Aug. 2024 to 8th Aug. 2024, Le-Times collaborated with Solana Beijing successfully organized an international Art Fair Market. Over 50 vendors from multiple countries gathered together in this market which brought clients something fresh with a multicultural taste. ",
              date: "08.2024",
              url: "https://le-times-website.oss-cn-beijing.aliyuncs.com/Blue_Ray.MP4"
            },
            {
              title: "1st International Temple Fair",
              description: "February 2024 Le-Times initiated  1st International Temple Fair at Floral Village Outlets Shopping Park. During the event, Le-Times curated products from different countries across Europe, the Americas, Africa, and beyond, together with tailor-made live performances by international artists and dynamic shows, which garnered extraordinary acclaim from clients and also achieved a great success! . ",
              date: "02.2024",
              url: "https://le-times-website.oss-cn-beijing.aliyuncs.com/Floral_Village_Outlets.m4v"
            },
          ];
        }
      }
    },
    initTouchEvents() {
      const container = this.$refs.newsContainer;
      
      container.addEventListener('touchstart', (e) => {
        this.touchStartY = e.touches[0].clientY;
      }, { passive: true });
      
      container.addEventListener('touchmove', (e) => {
        if (this.isScrolling) return;
        
        const touchY = e.touches[0].clientY;
        const diff = this.touchStartY - touchY;
        
        if (Math.abs(diff) > 50) {
          this.isScrolling = true;
          
          if (diff > 0 && this.currentIndex < this.videos.length - 1) {
            // 向上滑动，显示下一个视频
            this.currentIndex++;
          } else if (diff < 0 && this.currentIndex > 0) {
            // 向下滑动，显示上一个视频
            this.currentIndex--;
          }
          
          setTimeout(() => {
            this.isScrolling = false;
          }, 500);
        }
      }, { passive: true });
    },
    handleVideoPlay(index) {
      // 暂停其他视频
      this.videos.forEach((_, i) => {
        if (i !== index) {
          const videoEl = this.$el.querySelectorAll('.video-player')[i];
          if (videoEl) videoEl.pause();
        }
      });
    },
    handleVideoPause(index) {
      // 视频暂停时的处理
      console.log(`Video ${index} paused`);
    },
    hideScrollIndicatorAfterDelay() {
      setTimeout(() => {
        this.showScrollIndicator = false;
      }, 3000);
    }
  }
};
</script>

<style scoped>
.blank{
  height: 80px;
  color: rgba(0, 0, 0, 0.05);
}
.ending{
  height: 80px;
  color: rgba(0, 0, 0, 0.05);
}

.timeline {
  height: 100%;
  width: 10%;
  align-items: center;
}

.timeline-container {
  position: absolute;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.timeline-line {
  width: 0.2rem;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.85);
  position: absolute;
}

.timeline-dot {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background-color: #DEBE84;
  position: relative;
  z-index: 1;
  margin: 20px 0;
}

.date {
  width: 15%;
  text-align: center;
  margin-top: 20px;
  color: #fedfa6;
  font-size: 1.2rem;
  justify-content: flex-start; /* 顶部对齐 */

}
.news-container {
  height: auto;
  width: 100vw;
  overflow: hidden;
  position: relative;
  background: url(../assets/background.png) repeat center center;
  background-size: 100% auto;
}

.video-list {
  margin-left: 15%;
  height: auto;
  width: 60%;
  margin-top: 20px;
  transition: transform 0.5s ease;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
}

.video-item {
  height: auto;
  width: 100%;
  display: flex;

  position: relative;
  padding: 0px;
  box-sizing: border-box;
}

.video-player {
  width: 100%;
  max-height: 60vh;
  background-color: #000;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.video-content {
  width: 75%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: left;
  margin-bottom: 32px;
}

.video-info {
  margin-top: 20px;
  text-align: center;
}

.video-title {
  font-size: 1.5rem;
  color: #ffffff;
  margin-bottom: 20px;
  text-align: left;
}

.video-desc {
  width: 100%;
  font-size: 1rem;
  color: #ffffff;
  line-height: 1.5;
  margin-bottom: 8px;
  text-align: left;
}


.scroll-indicator {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  color: #666;
  font-size: 0.9rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: bounce 2s infinite;
}

.arrow-down {
  width: 20px;
  height: 20px;
  border-left: 2px solid #666;
  border-bottom: 2px solid #666;
  transform: rotate(-45deg);
  margin-top: 5px;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0) translateX(-50%);
  }
  40% {
    transform: translateY(-10px) translateX(-50%);
  }
  60% {
    transform: translateY(-5px) translateX(-50%);
  }
}

@media (max-width: 768px) {
  .news-container{
    background: url(../assets/background.png) repeat top center;
    background-size: auto 100vh;
  }
  .video-list{
    margin-left: 5%;
    width: 90%;
  }
  .video-title{
    font-size: 1.2rem;
  }

  .date {
  width: 15%;
  text-align: center;
  margin-top: 20px;
  color: #fedfa6;
  font-size: 1rem;
  justify-content: flex-start; /* 顶部对齐 */
  position: relative;

}
}
</style>